import { BaseGenerator } from '../core/BaseGenerator.js';

/**
 * Mexican RFC generator following Single Responsibility Principle
 */
export class RfcGenerator extends BaseGenerator {
  generate(options = {}) {
    const { isCompany = false } = options;

    // Generate letters (3 for individuals, 4 for companies)
    const letterCount = isCompany ? 4 : 3;
    let letters = '';
    for (let i = 0; i < letterCount; i++) {
      letters += this.randomLetter();
    }

    // Generate date (YYMMDD)
    const year = this.padZero(this.randomInt(50, 99), 2); // 1950-1999 or 2000-2049
    const month = this.padZero(this.randomInt(1, 12), 2);
    const day = this.padZero(this.randomInt(1, 28), 2); // Safe day range

    // Generate homoclave (2 alphanumeric) + check digit (1 alphanumeric)
    const homoclave = this.randomLetter() + this.randomInt(0, 9);
    const checkDigit = this.randomLetter();

    return letters + year + month + day + homoclave + checkDigit;
  }
}